import { Streamingpackage } from '../../../../../interfaces/StreamingProvider.interface';
import { isValidPrice } from '../../../../../services/util/prices/comparePrices';

export function computeBestPrice(
  providers: Streamingpackage[],
  isMonthlySubscriptionPrefered: boolean
): number {
  const totalGreenPrice = providers.reduce((total, provider) => {
    const validMonthPrice: number | null = isValidPrice(
      provider.monthly_price_cents
    )
      ? provider.monthly_price_cents / 100
      : null;

    const validYearPrice: number | null = isValidPrice(
      provider.monthly_price_yearly_subscription_in_cents
    )
      ? provider.monthly_price_yearly_subscription_in_cents / 100
      : null;

    const greenPrice =
      isMonthlySubscriptionPrefered && validMonthPrice
        ? validMonthPrice
        : validYearPrice || validMonthPrice;

    if (greenPrice) {
      total += greenPrice;
    }

    return total;
  }, 0);

  return totalGreenPrice;
}
